<template>
<div id="Home" class="Home" >
  <div v-if="store_user.loggedIn">
    <div v-if="show_alerts" @click="alert = null">
      <div v-if="alert" :class="['alert', `alert-${alert.color}`]" role="alert">
        {{ alert.msg }}
        <div v-if="alert.click"> - Click <router-link  :to="{ name: alert.loc }">Here</router-link></div>
      </div>

      <div v-if="connected_msg">
        <div :class="['alert', `alert-${connected_msg.color}`]" role="alert">
          <b-icon-exclamation-triangle-fill />
          {{ connected_msg.msg }}: { {{ sensor }} }
          <div v-if="connected_msg.click"> - Click <router-link  :to="{ name: connected_msg.loc }">Here</router-link></div>
        </div>
      </div>

      <div v-show="loading_newDistance" class="alert alert-primary" role="alert">Waiting for Device ...</div>
    </div>

    <!-- Title -->
    <fieldset>
      <legend class="mb-4"><h2>My Water Softener</h2></legend>
    </fieldset>
    
    <ApexChart />
    <CardsView />
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import dbservice from '../services/dbservice.js';

import { db, auth } from "../firebase";

import CardsView from '@/views/CardsView.vue';
import ApexChart from '@/components/ApexChart.vue';

import axios from 'axios';

export default {
  name: 'Home',
  components: {
    ApexChart,
    CardsView,
  },
  data() {
    return {
      
      show_alerts: false,
      alert: null,
      recieved_msg: null,
      connected_msg: {
        "msg": `Your Sensor may not be Connected`,
        "click": false,
        "loc": '',
        "color": "warning"
      },

      uid: null,
      user: null,
      sensor: null,

      low_warning: null,
      loading_newDistance: false,

    }
  },
  methods: {

    alerts() {
      if ( ! this.sensor || this.sensor === "") {
        this.alert = {
          "type": "sensor",
          "msg": "Please Visit your Profile Page to and add your Sensor id to your new Account",
          "click": true,
          "loc": 'profile',
          "color": "primary"
        }
      }
    },
    async getDistance() {
      this.loading_newDistance = true;
      this.alert = null;
      // setTimeout(() => {
      //   if (this.loading_newDistance) {
      //     this.loading_newDistance = false;
      //     this.alert = {
      //       "type": "sensor",
      //       "msg": "Request Failed - Device could be disconnected",
      //       "click": false,
      //       "color": "danger"
      //     } 
      //     console.log("Force enabled the Refresh button")
      //   }
      // } , 30000)
      return await axios.get('https://us-central1-ezsalt-iot-dev-env.cloudfunctions.net/api/refresh',    
          { params: { uid: this.uid,  sid: this.sensor }, timeout: 3600 }
        )
        .then(res => {
          console.log("res", res.data)
          if (res.data.status === "success" || res.data.status === 'low_level' ) {
            this.connected_msg = null;

            if (this.alert) {
              if (this.alert.type === "sensor") {
                this.alert = null;
              }
            }
          }
          this.low_warning = res.data.message;
          this.loading_newDistance = false;
          setTimeout(() => {
            this.show_alerts = true;
            this.alerts();
          } , 1200)
          return res
        })
        .catch(error => {
          try {
            this.alert = {
              "type": "sensor",
              "msg": error.response.data.message,
              "click": false,
              "color": "danger"
            } 
            this.loading_newDistance = false;
            setTimeout(() => {
              // this.connected_msg = null;
              this.show_alerts = true;
              this.alerts();
            } , 1200)
          } catch {
            this.alert = {
              "type": "sensor",
              "msg": "Request Failed - Device could be disconnected",
              "click": false,
              "color": "danger"
            } 
            this.loading_newDistance = false;
            setTimeout(() => {
              this.show_alerts = true;
              this.alerts();
            } , 1200)
          }
        })
    },
  },
  computed: {
    ...mapGetters({
      store_user: "user"
    })
  },
  created() {

    auth.onAuthStateChanged(user => {
      if (user) {
        // User is signed in.
        this.uid = user.uid
        dbservice.getUserData(user.uid)
          .then(data => {
            this.user = data
            this.sensor = data.sensor

            this.getDistance()

            if ( ! this.sensor || this.sensor === "" ) {
              this.$router.push({ name: "profile"})
            }
          });

      } else {
      // No user is signed in. 

      }
    });
  }
}
</script>
